import {formatPhone} from '@deliveriesondemand/dod-utils';
import {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import {pdfUrl} from '-/api/api';
import NavigationService from '-/services/NavigationService';
import Button from '-/components/general/Button';
import {rem} from '-/styles/utils';
import {Logos} from '-/icons/icons';
import {get, pick} from '-/util/lodash';
import SessionService from '-/services/SessionService';

const styles = theme => ({
    root: {
        textAlign: 'center',
        maxWidth: rem(400),
        margin: 'auto auto',
        padding: rem(20)
    },
    a: {
        whiteSpace: 'nowrap',
        marginBottom: 15
    },
    privacy: {
        color: theme.colors.strong
    },
    phone: {
        color: theme.colors.primary
    },
    logoSection: {
        marginTop: 20,
        '& img': {
            marginRight:20,
            maxHeight: 60,
            verticalAlign: 'middle'
        }
    }
});

const LogoSection = props => {
    return (
        <div {...props}>
            <img src={Logos.NCUA} />
            <img src={Logos.EQUALHOUSING} />
        </div>
    );
};

class CallMeFooter extends Component {
    render() {
        const {address = {}, classes = {}, contactPhone, creditorId, currentStep, isCCRDomain, isCU, isDealer, offerId} = this.props;
        const callUsLink = <a className={classes.phone} href={`tel:${contactPhone}`}>{formatPhone(contactPhone)}</a>;
        const pdfOpts = {
            offerId,
            creditorId,
            isCCRDomain
        }
        const privacyLink = (
            <span className="privacy-statement">
                <a className={classes.privacy} href={pdfUrl(pdfOpts, 'privacy')} target="_blank" rel="noopener noreferrer">Privacy Statement</a>
            </span>
        );
        const termsLink = (
            <span className="privacy-statement">
                <a className={classes.privacy} href={pdfUrl(pdfOpts, 'terms')} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a><sup>*</sup>
            </span>
        );
        const {city, state, street1, street2, zip} = pick(address, ['city', 'state', 'street1', 'street2', 'zip']);
        const street = street2 ? `${street1}, ${street2}` : street1;

        switch (currentStep) {
            case 'callback':
                return null;
            default:
                return (
                    <div className={classes.root}>
                        <div>
                            <h2>Need help?</h2>
                            {isCU && (
                                <Fragment>
                                    <Button onClick={() => NavigationService.next('callback')} btnStyle="add" className={classes.a}>
                                        <i className="fa fa-phone" /> Schedule a Call
                                    </Button>
                                    <p className="info"> Or call us now at {callUsLink}.</p>
                                </Fragment>
                            )}
                            {isDealer && (
                                <Fragment>
                                    <p>For assistance, please contact us:</p>
                                    <p className="info" style={{margin: '15px 0'}}>
                                        {callUsLink}
                                        <br />
                                        {street}<br />
                                        {city}, {state} {zip}
                                    </p>
                                </Fragment>
                            )}
                            {privacyLink} | {termsLink}
                        </div>
                        {isCU && <LogoSection className={classes.logoSection} />}
                    </div>
                );
        }
    }
}

const mapStateToProps = (state, hasOwnProps) => {
    const {contactPhone} = state.config;
    const {offerId} = hasOwnProps;
    const {currentStep} = state.navigation;
    const type = get(state, 'creditor.type');
    const address = get(state, 'creditor.address');
    const creditorId = get(state, 'creditor._id');
    const isCCRDomain = SessionService.isCCRDomain(); 

    return {
        address,
        contactPhone,
        creditorId,
        currentStep,
        isCCRDomain,
        offerId,
        isCU: type === 'creditUnion',
        isDealer: type === 'dealer'
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(CallMeFooter));
